<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal neg-modal--estreito">
      <q-card-section class="neg-modal__titulo">Corrigir recebimento</q-card-section>

      <q-card-section class="neg-modal__corpo">
        <negocios-campo-data
          label="Data"
          :clearable="false"
          :value="dados.data"
          :error="Boolean(erros.data)"
          :error-message="primeiroErro('data')"
          @input="dados.data = $event"
        />

        <q-field
          v-model="dados.valor"
          dense
          stack-label
          label="Valor"
          :error="Boolean(erros.valor)"
          :error-message="primeiroErro('valor')"
        >
          <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
            <money-input
              :id="id"
              class="q-field__native text-right"
              :value="modelValue"
              v-bind="moneyFormat"
              v-show="floatingLabel"
              @input="emitValue"
            />
          </template>
        </q-field>

        <q-toggle v-model="estorno" label="Devolução ao banco" />

        <q-input v-model="dados.observacao" dense clearable label="Observação" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          no-caps
          color="negative"
          label="Excluir"
          :loading="excluindo"
          @click="excluir"
        />
        <q-space />
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Salvar"
          :loading="salvando"
          @click="salvar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import MoneyInput from "@/components/Utils/money-input.vue";
import negociosMixin from "@/mixins/negocios";

export default {
  name: "negocios-modal-recebimento",

  emits: ["update:modelValue", "mudou"],
  components: { MoneyInput },
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    recebimento: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dados: { data: null, valor: 0, observacao: null },
      estorno: false,
      salvando: false,
      excluindo: false,
      erros: {}
    };
  },
  watch: {
    modelValue(aberto) {
      if (!aberto || !this.recebimento) {
        return;
      }

      this.erros = {};
      this.estorno = Number(this.recebimento.valor) < 0;
      this.dados = {
        data: this.recebimento.data,
        valor: Math.abs(Number(this.recebimento.valor || 0)),
        observacao: this.recebimento.observacao
      };
    }
  },
  methods: {
    salvar() {
      this.salvando = true;
      this.erros = {};

      const dados = {
        data: this.dados.data,
        valor: this.estorno ? -Number(this.dados.valor || 0) : Number(this.dados.valor || 0),
        observacao: this.dados.observacao
      };

      this.$store
        .dispatch("salvarNegociosRecebimento", { id: this.recebimento.id, dados })
        .then(resposta => this.concluir(resposta));
    },
    excluir() {
      this.excluindo = true;

      this.$store
        .dispatch("excluirNegociosRecebimento", this.recebimento.id)
        .then(resposta => this.concluir(resposta));
    },
    concluir(resposta) {
      this.salvando = false;
      this.excluindo = false;

      if (!resposta.success) {
        this.erros = resposta.errors || {};
      }

      this.avisar(resposta.message, resposta.success ? "green" : "orange");

      if (resposta.success) {
        this.$emit("mudou");
        this.$emit("update:modelValue", false);
      }
    }
  }
};
</script>
